// extracted by mini-css-extract-plugin
export default {"item":"service-form_item__VMJAp","label":"service-form_label__9C0YJ","value":"service-form_value__TrYdA"};